export default "__VITE_ASSET__CpNdXE$9__"